import {
  ComboboxProps as MantineComboboxProps,
  Combobox as MantineCombobox,
} from '@mantine/core';

export type ComboboxProps = MantineComboboxProps;

export const Combobox = (props: ComboboxProps) => {
  return <MantineCombobox {...props} />;
};

Combobox.displayName = 'Combobox';
